import React from "react";

const Icon = ({ name }) => {
  if (name === "plus") {
    return (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path
          d="M12 5v14M5 12h14"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
    );
  }
  if (name === "user-change") {
    return (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path
          d="M7 7h9a4 4 0 0 1 0 8H9"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M10 4 7 7l3 3M17 20l3-3-3-3"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }

  return null;
};
/**
 * ボタンコンポーネント
 * @param {string} title ボタンタイトル
 * @param {string} icon アイコン名
 * @param {boolean} disabled 押下不可かどうか
 * @param {Function} onClick ボタン押下時の処理
 * @param {string} className クラス名
 * @class Button
 */
export default function Button({
  title,
  icon,
  onClick,
  disabled,
  className = "",
}) {
  return (
    <button
      className={`btn ${className}`}
      onClick={onClick}
      disabled={disabled}
    >
      <Icon name={icon} />
      {title}
    </button>
  );
}
